import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fetchContentCollection } from "../../../behavior/api/content";
import { PageRoute } from "../../../constants";
import { Alert, Button, Text } from "../../elements";

const AlertInfoLink = () => {
    const { t } = useTranslation();
    const { data: contentCollection, isLoading: loading } = useQuery({
        queryKey: ["contentCollection", { tags: ["Dashboard Interview Tips"], limit: 1 }],
        queryFn: fetchContentCollection({
            tags: ["Dashboard Interview Tips"],
            optionalTags: [],
            page: 1,
            limit: 1,
        }),
    });

    const hasContent = !loading && contentCollection?.contents && contentCollection.contents.length > 0;
    const article = hasContent ? contentCollection.contents[0] : undefined;

    return (
        <Alert type="info" className="custom-alert">
            <Text className="me-2">{t("Interview.HowToImproveAtInterviews.Alert_WantMoreAdvice")}</Text>
            <Button
                secondary
                link
                className="alert-link-button mobile-text-sm"
                to={article ? `${PageRoute.LEARN_WITH_HUBERT_ARTICLE}/${article.id}` : PageRoute.LEARN_WITH_HUBERT}
            >
                {t("Interview.HowToImproveAtInterviews.AlertLink_ExploreOurGeneralAdviceArticle")}
                <ArrowRight size={16} className="ms-1.5 rtl:-scale-x-100" />
            </Button>
        </Alert>
    );
};

export default AlertInfoLink;
